import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() previousLabel = 'Previous';
  @Input() nextLabel = 'Next';
  @Output() pageSet: EventEmitter<number> = new EventEmitter();
  @Input() currentPage = 1;

  constructor() {}

  ngOnInit() {}

  getPageCount(): number {
    let pageCount = 0;

    if (
      this.totalItems &&
      this.totalItems > 0 &&
      this.itemsPerPage &&
      this.itemsPerPage > 0
    ) {
      pageCount = Math.floor(this.totalItems / this.itemsPerPage);
      if (this.totalItems % this.itemsPerPage !== 0) {
        pageCount++;
      }
    }

    return pageCount;
  }

  getPageCountRange(): number[] {
    let pages: number[] = [];

    if (this.getPageCount() > 0) {
      pages = Array.from(Array(this.getPageCount()), (x, i) => i + 1);
    }

    return pages;
  }

  setPage(page: number) {
    if (page > 0 && page <= this.getPageCount()) {
      this.currentPage = page;
      this.pageSet.emit(this.currentPage);
    }
  }
}
